import firebase from 'firebase/app'
import firestore from 'firebase/firestore'

// Initialize Firebase
var config = {
    apiKey: "AIzaSyCX27zqoFOSEZ65ymULavg7NiZPtSXfVuw",
    authDomain: "vuetutorial-ninja-chat.firebaseapp.com",
    databaseURL: "https://vuetutorial-ninja-chat.firebaseio.com",
    projectId: "vuetutorial-ninja-chat",
    storageBucket: "vuetutorial-ninja-chat.appspot.com",
    messagingSenderId: "85576473865"
};

const firebaseApp = firebase.initializeApp(config);

firebaseApp.firestore().settings({ timestampsInSnapshots: true })

export default firebaseApp.firestore()


// WEBPACK FOOTER //
// ./src/firebase/init.js